import React from "react";
import { Copy } from "./buttons/Copy";
import { Share } from "./buttons/Share";
import { useProductDispatch, useProductSelector } from "../../stores/product/product.store";
import { ProductState } from "../../stores/product/product-state.interface";
import { gtag } from "../../stores/product/product.reducer";
import { ProductInterface } from "../../interfaces/product/product.interface";

interface SkuProps {
    product: ProductInterface;
    className?: string;
}

export const Sku: React.FC<SkuProps> = ({ product, className= '' }) => {
    const translate = useProductSelector((state: ProductState) => state.translate);
    const dispatch = useProductDispatch();
    const copy = () => {
        navigator.clipboard.writeText(product.sku);
        dispatch(gtag('mn_item_id_copy'));
    }

    return (
        <div className={ `flex items-center mt-5 ${ className }` }>
            <div className="flex items-center">
                <p className="text-[14px] text-[#585858] mr-2">{ translate.sku } <span onCopy={ () => copy }>{ product.sku }</span></p>
                <div className="mr-4"><Copy onClick={ copy }/></div>
            </div>
            <Share title={ product.name } url={ product.url } text={ product.name }/>
        </div>
    )
}